import { ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

export type DrillStep = { label: string; active?: boolean; onClick?: () => void }

/** The audit trail: risk summary → barrier → module → control → evidence. */
export function DrillBreadcrumb({ steps }: { steps: DrillStep[] }) {
  return (
    <nav className="flex flex-wrap items-center gap-1.5 text-[12.5px] text-muted-foreground">
      {steps.map((s, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="size-3 text-faint" />}
          <button
            onClick={s.onClick}
            className={cn(
              'rounded border bg-surface-2 px-2 py-1',
              s.active && 'border-primary text-foreground',
            )}
          >
            {s.label}
          </button>
        </span>
      ))}
    </nav>
  )
}
